import { Form, Input, message, Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { CreateCompany } from '../../../apis/Brand/Company/CreateCompany';
import { useGlobalState } from '../../../store/state';
import { GetCompanyList } from '../../../utils/GetCompanyList';

const { Item } = Form;
const BrandCreateCompanyComponent = ({ onClose, redirect }) => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [formCreateCompany] = Form.useForm();

  const onFormSubmit =(value) =>{
    CreateCompany(user.accessToken, value).then(({ response, status }) =>{
      if (status === 200) {
        GetCompanyList(response.id, false, user.accessToken, company);
        if (redirect) {
          // console.log("ready to move to brand page")
          history.push(redirect); // @note: redirecting to metnioned redirect
        } else {
          // @note: creation happening from inside module
          message.success('New company added successfully & selected as active');
          onClose();
        }
        formCreateCompany.resetFields();
      } else {
        message.error('there is some issue with company creation');
      }
    });
  };
  return (
    <Form
      form={formCreateCompany}
      layout="vertical"
      name="createCompany"
      requiredMark={false}
      onFinish={onFormSubmit}
    >
      <Item
        label="Enter your company name"
        name="companyname"
        rules={[{ required: true, message: 'Please enter your company name' }]}
      >
        <Input className="common_input"
          size="large"
          type="text"
          placeholder="Eg: Lorem ipsum company" />
      </Item>
      <div className="text-right">
        <Button htmlType="submit"
          className="common_button">Create Company</Button>
      </div>
    </Form>
  );
};

export default BrandCreateCompanyComponent;
